import { AbstractControl } from '@angular/forms';
import moment from 'moment';
import { environment } from '@environments/environment';

export class AgeValidator {
  static ageValidator(AC: AbstractControl): { [key: string]: boolean } {
    if (!AC.value) {
      return null;
    } else {
      const inputDateString = AC.value.dateString;

      const isValidBirthDate = inputDateString && inputDateString.length >= 10;
      if (!isValidBirthDate) {
        return null;
      }
      const date = new Date(moment(inputDateString, 'DD-MM-YYYY').format());
      const deltaMillisecs = new Date().getTime() - date.getTime();
      const age = deltaMillisecs / (1000 * 60 * 60 * 24 * 365.25);

      const { minAge, maxAge } = environment.userData;

      if (AC && AC.value && (age < minAge || age > maxAge)) {
        return { ageValidator: true };
      }
      return null;
    }
  }
}
